import React, { useMemo } from 'react';
import { ColorPickerField } from '@/components/core/Form';
import { useFocusIdx } from '@/hooks/useFocusIdx';

export function ContainerBackgroundColor({ title = 'Container background color' }: { title?: string; }) {
  const { focusIdx } = useFocusIdx();

  return useMemo(() => {
    return (
      <ColorPickerField
        label={title}
        name={`${focusIdx}.attributes.container-background-color`}
        inline
        alignment='center'
      />
    );
  }, [focusIdx, title]);
}
